export default {
  model () {
    return {
      layoutId: null,
      periodId: null,
      startDate: null,
      endDate: null
    }
  },
  validations: {
    layoutId: [{required: true, message: 'Debe de seleccionar un layout para la evaluación'}],
    periodId: [{required: true, message: 'Debe de seleccionar un periodo'}],
    startDate: [{required: true, message: 'La fecha de inicio es requerida'}],
    endDate: [{required: true, message: 'La fecha de fin es requerida'}]
  }
}



// WEBPACK FOOTER //
// ./src/modules/assignments/assignments.model.js